import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Footer from "../../partials/footer";
import Navigation from "../../partials/navigation";
import ManagementMenu from "./partials/menu";
import { Switch, Route } from "react-router-dom";
import Overview from "./Overview";
import Site from "./Site";
import ParentSite from "./ParentSite";
import { appName } from "../../app.json";
import Ward from "./Ward";
import Designation from "./Designation";
import Assessment from "./Assessment";
import AssessmentQuestionOption from "./Assessment/Option-Question";
import Department from "./Department";
import LeaveType from "./LeaveType";
import LeaveStatus from "./LeaveStatus";
import SuperAdmin from "./SuperAdmin";
import NoteCategory from "./NoteCategory";
import SiteType from "./SiteType";
import ActivityLog from "./ActivityLog";
import Subscription from "./Subscription";
import SiteDetail from "./Site/detail";
import SubscriptionDetail from "./Subscription/Detail";
import DutyPeriod from "./DutyPeriod";
import AllergyIndex from "./Allergy";
import StaffType from "./StaffType";
import CareNoteCategory from "./CareNoteCategory";

class AppManager extends Component {
    render() {
        return (
            <>
                <div className="page-wrapper">
                    <Helmet>
                        <title>Application Management | {appName}</title>
                    </Helmet>
                    <Navigation history={this.props.history} />
                    <div className="page-container">
                        <ManagementMenu path={this.props.match.path} />
                        <div className="page-content-wrapper page-content-wrapper-home">
                            <div className="page-content page-content-home">
                                <Switch>
                                    <Route exact path="/home/app-management" component={Overview}></Route>
                                    <Route path="/home/app-management/site" component={Site}></Route>
                                    <Route path="/home/app-management/parent-site" component={ParentSite}></Route>
                                    <Route path="/home/app-management/ward" component={Ward}></Route>
                                    <Route path="/home/app-management/designation" component={Designation}></Route>
                                    <Route path="/home/app-management/department" component={Department}></Route>
                                    <Route path="/home/app-management/assessment/type-category" component={Assessment}></Route>
                                    <Route path="/home/app-management/leave-type" component={LeaveType}></Route>
                                    <Route path="/home/app-management/leave-status" component={LeaveStatus}></Route>
                                    <Route path="/home/app-management/assessment/question-option" component={AssessmentQuestionOption}></Route>
                                    <Route path="/home/app-management/super-admin" component={SuperAdmin}></Route>
                                    <Route path="/home/app-management/note-category" component={NoteCategory}></Route>
                                    <Route path="/home/app-management/site-type" component={SiteType} />
                                    <Route exact path="/home/app-management/service-sub" component={Subscription} />
                                    <Route path="/home/app-management/service-sub/:id" component={SubscriptionDetail} />
                                    <Route path="/home/app-management/site-detail/:id" component={SiteDetail} />
                                    <Route path="/home/app-management/activity-log" component={ActivityLog} />
                                    <Route path="/home/app-management/duty-period" component={DutyPeriod} />
                                    <Route path="/home/app-management/patient-allergy" component={AllergyIndex} />
                                    <Route path="/home/app-management/staff-type" component={StaffType} />
                                    <Route path="/home/app-management/care-note-category" component={CareNoteCategory} />
                                </Switch>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }
}

export default AppManager;
